import React, {useState} from 'react';
import {Box, Card, CardContent, Grid, IconButton, Tooltip, Typography} from "@deere/fuel-react"
import {DataGrid, GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import {useStyles} from '../shared/styles/RatingsPastPerformance';
import {Fullscreen, FullscreenExit} from '@material-ui/icons/';

export const RatingsPastPerformanceOverviewCard = ({pastPerformance}) => {
    const classes = useStyles();
    const columns = [{
        field: 'id',
        headerName: 'ID',
        hide: true
    }, {
        field: 'supplierNumber',
        headerName: 'Supplier Number',
        hide: true
    }, {
        field: 'fiscalYear',
        headerName: 'Year',
    }, {
        field: 'groupName',
        headerName: 'Unit / Parent',
        flex: 1
    }, {
        field: 'groupUnit',
        headerName: 'Group Unit',
        hide: true
    }, {
        field: 'functionalArea',
        headerName: 'Functional Area',
        hide: true
    }, {
        field: 'subFuncArea',
        headerName: 'Sub Functional Area',
        hide: true
    }, {
        field: 'finalClassCode',
        headerName: 'Final Class Code',
        hide: true
    }, {
        field: 'classificationDesc',
        headerName: 'Classification',
        flex: 1
    }, {
        field: 'totalScore',
        headerName: 'Total Points',
        flex: 1,
        valueFormatter: ({value}) => value > 0 ? value : ""
    }, {
        field: 'qualityScore',
        headerName: 'Quality',
        flex: 1,
        valueFormatter: ({value}) => value > 0 ? value : ""
    }, {
        field: 'deliveryScore',
        headerName: 'Delivery',
        flex: 1,
        valueFormatter: ({value}) => value > 0 ? value : ""
    }, {
        field: 'processAlignmentScore',
        headerName: 'Process Alignment',
        flex: 1,
        valueFormatter: ({value}) => value > 0 ? value : ""
    }, {
        field: 'relationshipScore',
        headerName: 'Relationship',
        flex: 1,
        valueFormatter: ({value}) => value > 0 ? value : ""
    }, {
        field: 'valueCreationScore',
        headerName: 'Value Creation',
        flex: 1,
        valueFormatter: ({value}) => value > 0 ? value : ""
    }, {
        field: 'hofAwards',
        headerName: 'Hall Of Fame',
        flex: 1
    }, {
        field: 'specialAwards',
        headerName: 'Special Awards',
        width: 150
    }];
    const [isFullScreen, setIsFullScreen] = useState(false);

    const CustomToolbar = () => {
        return (
          <GridToolbarContainer>
            <GridToolbarExport csvOptions={{ fields: columns.map((column) => column.field).filter((field) => field !== 'id') }}/>
          </GridToolbarContainer>
        );
    }

    return (
        <Grid item xs={12}>
            <Box
                p={2}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    gap: '20px'
                }}
            >
                <Card style={isFullScreen ? {
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    width: '100%',
                    zIndex: '1000'
                } : {
                    width: '100%'
                }}>
                    <CardContent style={{ width: '100%' }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <Typography variant='h2'>AE Rating Performance</Typography>
                            <Tooltip
                                placement='bottom'
                                title={isFullScreen ? 'Collapse' : 'Expand'}
                            >
                                <Box>
                                    <IconButton onClick={() => setIsFullScreen((prev) => !prev)}>
                                        {isFullScreen ? <FullscreenExit/> : <Fullscreen/>}
                                    </IconButton>
                                </Box>
                            </Tooltip>
                        </Box>
                        
                        <DataGrid
                            autoHeight={true}
                            checkboxSelection={false}
                            className={classes.root}
                            columns={columns}
                            components={{
                                Toolbar: CustomToolbar,
                            }}
                            disableSelectionOnClick
                            rows={pastPerformance}
                        />
                    </CardContent>
                </Card>
            </Box>
        </Grid>
    )
}